import {parseQueryString, removeURLParameter} from '../../utils/url'
import {Attribution} from './types'

export const readSuppliedAttribution = (queryString: string): Attribution => {
  const parameters = parseQueryString<Record<string, string>>(queryString, true)

  return {
    vtmSrc: parameters.vtm_src || '',
    label: parameters.label || '',
    vclid: parameters.vclid || ''
  }
}

/**
 * Only `vclid` leaves the address bar. `vtm_src` and `label` stay so internal
 * links carry them to the next landing, which then matches the store.
 */
export const stripVclidFromUrl = () => {
  const strippedUrl = removeURLParameter(location.href, 'vclid')

  if (strippedUrl !== location.href) {
    history.replaceState(history.state, '', strippedUrl)
  }
}
